import React, { Children } from 'react';
import { Award, Users, Smartphone, BarChart3 } from 'lucide-react';
import { motion } from 'framer-motion';
const Services = () => {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="servicios" className="py-20 md:py-32 bg-benefika-light" data-id="element-209">
      <div className="container mx-auto px-4" data-id="element-210">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={itemVariants} className="text-center mb-16" data-id="element-211">
          <h2 className="text-3xl md:text-5xl font-bold text-benefika-charcoal mb-6 tracking-tight" data-id="element-212">
            Nuestras Soluciones
          </h2>
          <p className="text-lg text-benefika-gray max-w-3xl mx-auto leading-relaxed" data-id="element-213">
            Ofrecemos un ecosistema completo para la creación, administración y
            optimización de programas de fidelización y beneficios, adaptados a
            las necesidades de su empresa, organización o institución.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-214">
          {/* Service 1 */}
          <motion.div variants={itemVariants} className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group" data-id="element-215">
            <div className="w-16 h-16 bg-benefika-teal/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-216">
              <Award className="text-benefika-teal w-8 h-8" data-id="element-217" />
            </div>
            <h3 className="text-2xl font-bold text-benefika-charcoal mb-4" data-id="element-218">
              Programas de Fidelización
            </h3>
            <p className="text-benefika-gray mb-6 leading-relaxed" data-id="element-219">
              Diseñamos y gestionamos programas de lealtad a medida que aumentan
              la retención de clientes y maximizan su valor a largo plazo.
            </p>
            <ul className="space-y-3 text-benefika-gray" data-id="element-220">
              <li className="flex items-start" data-id="element-221">
                <span className="text-benefika-teal mr-3 font-bold" data-id="element-222">•</span>
                Estrategias de recompensas personalizadas
              </li>
              <li className="flex items-start" data-id="element-223">
                <span className="text-benefika-teal mr-3 font-bold" data-id="element-224">•</span>
                Sistemas de puntos y niveles (tiers)
              </li>
              <li className="flex items-start" data-id="element-225">
                <span className="text-benefika-teal mr-3 font-bold" data-id="element-226">•</span>
                Gestión de catálogos de beneficios
              </li>
            </ul>
          </motion.div>

          {/* Service 2 */}
          <motion.div variants={itemVariants} className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group" data-id="element-227">
            <div className="w-16 h-16 bg-benefika-amber/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-228">
              <Smartphone className="text-benefika-amber w-8 h-8" data-id="element-229" />
            </div>
            <h3 className="text-2xl font-bold text-benefika-charcoal mb-4" data-id="element-230">
              Plataformas Digitales
            </h3>
            <p className="text-benefika-gray mb-6 leading-relaxed" data-id="element-231">
              Desarrollamos e implementamos tecnología de punta para que sus
              clientes accedan a sus beneficios de manera intuitiva y rápida.
            </p>
            <ul className="space-y-3 text-benefika-gray" data-id="element-232">
              <li className="flex items-start" data-id="element-233">
                <span className="text-benefika-amber mr-3 font-bold" data-id="element-234">•</span>
                Aplicaciones móviles marca blanca
              </li>
              <li className="flex items-start" data-id="element-235">
                <span className="text-benefika-amber mr-3 font-bold" data-id="element-236">•</span>
                Portales web de beneficios
              </li>
              <li className="flex items-start" data-id="element-237">
                <span className="text-benefika-amber mr-3 font-bold" data-id="element-238">•</span>
                Integración API con sus sistemas actuales
              </li>
            </ul>
          </motion.div>

          {/* Service 3 */}
          <motion.div variants={itemVariants} className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group" data-id="element-239">
            <div className="w-16 h-16 bg-benefika-emerald/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-240">
              <Users className="text-benefika-emerald w-8 h-8" data-id="element-241" />
            </div>
            <h3 className="text-2xl font-bold text-benefika-charcoal mb-4" data-id="element-242">
              Gestión de Relaciones (CRM)
            </h3>
            <p className="text-benefika-gray mb-6 leading-relaxed" data-id="element-243">
              Implementamos estrategias efectivas para fortalecer el vínculo
              emocional con sus clientes mediante comunicación asertiva.
            </p>
            <ul className="space-y-3 text-benefika-gray" data-id="element-244">
              <li className="flex items-start" data-id="element-245">
                <span className="text-benefika-emerald mr-3 font-bold" data-id="element-246">•</span>
                Segmentación avanzada de audiencias
              </li>
              <li className="flex items-start" data-id="element-247">
                <span className="text-benefika-emerald mr-3 font-bold" data-id="element-248">•</span>
                Campañas de comunicación multicanal
              </li>
              <li className="flex items-start" data-id="element-249">
                <span className="text-benefika-emerald mr-3 font-bold" data-id="element-250">•</span>
                Automatización de marketing (Marketing Automation)
              </li>
            </ul>
          </motion.div>

          {/* Service 4 */}
          <motion.div variants={itemVariants} className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group" data-id="element-251">
            <div className="w-16 h-16 bg-benefika-gold/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-252">
              <BarChart3 className="text-benefika-gold w-8 h-8" data-id="element-253" />
            </div>
            <h3 className="text-2xl font-bold text-benefika-charcoal mb-4" data-id="element-254">
              Análisis y Métricas
            </h3>
            <p className="text-benefika-gray mb-6 leading-relaxed" data-id="element-255">
              Convertimos los datos de sus clientes en insights accionables para
              optimizar continuamente su programa de lealtad.
            </p>
            <ul className="space-y-3 text-benefika-gray" data-id="element-256">
              <li className="flex items-start" data-id="element-257">
                <span className="text-benefika-gold mr-3 font-bold" data-id="element-258">•</span>
                Dashboards en tiempo real
              </li>
              <li className="flex items-start" data-id="element-259">
                <span className="text-benefika-gold mr-3 font-bold" data-id="element-260">•</span>
                Análisis de comportamiento y redención
              </li>
              <li className="flex items-start" data-id="element-261">
                <span className="text-benefika-gold mr-3 font-bold" data-id="element-262">•</span>
                Medición de ROI y Customer Lifetime Value
              </li>
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};
export default Services;